import { Style } from 'es-map-widget';
import { useCallback, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { api } from '../../hooks/useApi';
import { styles } from '../mapwrapper/MapWrapperStyles';

export default function DamageChronologyDataprovider({ extent, layerData, setSource }) {
    const { id } = useParams();
    const getLayer = useCallback(
        async (controller, params) =>
            api.layers
                .getDamageChronology(params, { signal: controller.signal })
                .then((res) => res.data),
        [api]
    );

    const addStyleToGeoms = (geoms) =>
        geoms.map((e) => ({
            ...e,
            style: new Style({
                ...styles.frostDamage(e.value),
            }),
        }));

    useEffect(() => {
        if (!layerData.isLayerVisible) {
            setSource(null);
            return;
        }

        const controller = new AbortController();

        getLayer(controller, {
            extent,
        })
            .then((layer) => setSource(addStyleToGeoms(layer)))
            .catch((err) => {
                if (err.code !== 'ERR_CANCELED') {
                    console.error(err);
                }
            });

        // eslint-disable-next-line consistent-return
        return () => {
            controller.abort();
        };
    }, [getLayer, extent, layerData, id, addStyleToGeoms, setSource]);
    return null;
}
